import { Tooltip as AntdTooltip } from 'antd';
import { theme } from 'shared/constants/theme';
import { useLiveRegion } from 'src/hooks/accessibility';

/**
 * @typedef {import('antd').TooltipProps & {
 *  announceOnOpen?: boolean
 * }} TooltipProps
 */

/**
 * @param {TooltipProps} props
 */
export function Tooltip({
  title,
  placement = 'topLeft',
  color = theme.tooltipColor,
  announceOnOpen = true,
  children,
  onOpenChange,
  ...props
}) {
  const { announce, liveRegion } = useLiveRegion();

  const handleOpenChange = open => {
    if (open && title && announceOnOpen) {
      // Extract text content for screen reader
      const text = typeof title === 'string' ? title : '';
      announce(text);
    }
    onOpenChange?.(open);
  };

  return (
    <>
      <AntdTooltip
        title={title}
        placement={placement}
        arrow={{ pointAtCenter: true }}
        mouseEnterDelay={0.8}
        color={color}
        key={color}
        trigger={['focus', 'hover']}
        {...props}
        onOpenChange={handleOpenChange}
      >
        {children}
      </AntdTooltip>
      {/* Screen reader live region */}
      {liveRegion}
    </>
  );
}
